import { useState, useEffect, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { TENANT_PLATFORM } from "@hiver/bifrost-js";

import { AutherContext, ToastContext } from "../Context";
import { setState } from "../../Constant/LocalStorage";
import {
  userAuth,
  addUserToUserGroup,
  newHiverLoginInit,
  getLoggedInUserDetails
} from "../../Service/LoginServices";
import { open_popup, onOAuthSuccess } from "../../Pages/Onboarding/LoginPage/utils";
import { getAppConfig } from "../../Bifrost/api";
import { initConnectorsBifrost } from "../../Bifrost";

// redirectPage not required. mocking setRedirectPage
const setRedirectPage = () => {};

export function NewAutherProvider(props) {
  const { setNoNet, setShowToast } = useContext(ToastContext);
  const [showError, setShowError] = useState(false);
  const [authers, setAuthers] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [email, setEmail] = useState('');
  const [refetchToken, setRefetchToken] = useState(false);
  const [authToken, setAuthToken] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [userSession, setUserSession] = useState(false);
  const [redirectToken, setRedirectToken] = useState(true);
  const [userDetails, setUserDetails] = useState(false);
  const [tenant, setTenant] = useState(null);
  const navigate = useNavigate();

  const getGoogleAuthUrl = ({email}) => {
    //This is called once to get the redirect url as soon as user clicks login
    if (email) {
      return new Promise((resolve, reject) => {
        newHiverLoginInit({ email, json_mode: 1, _csrf_token: undefined }).then((res) => {
          if (res.status === 200) {
            const { redirect_url } = res?.data ?? {};
            resolve(redirect_url);
          }
          else throw new Error('Login init failed');
        }).catch(err => {
          console.error(err);
          reject('');
        });
      })
    }
    return new Promise((_res,rej) => console.error('No Email Present') && rej(''));
  }

  const initiateAuth = useCallback(({showMessage = true} = {}) => {
    getLoggedInUserDetails().then((response) => {
        const { data } = response || {};
        if (!data) return;
        setUserDetails(data);
        const { user_id, usergroup_id, tenantPlatform, getTokenForLogin } = data;
        const { appEnv, tier } = getAppConfig();
        initConnectorsBifrost( { 
          appEnv,
          tier,
          userId: user_id,
          userGroupId: usergroup_id,
          tenantPlatform,
          getTokenForLogin
        })
        setTenant(tenantPlatform || TENANT_PLATFORM.GMAIL);
        setAuthToken(true);
        window.aptrinsic(
        "identify",
        {
            id: user_id,
        },
        {
            usergroupid: usergroup_id,
        }
        );

        return addUserToUserGroup();
    }).catch( err => {
        //removing axios layer:
        throw err?.response;
    }).then(() => {
      setNoNet(false);
      return userAuth();       
    }).then((res) => {
      let user = res?.data?.user;
      setAdmin(user);
      setNoNet(false);
      setRedirectToken(true);
    })
    .catch((rej) => {
      const noNet = rej?.message === "Network Error";
      setNoNet(noNet);
      if(showMessage)setShowToast(rej?.data?.message);
      setAdmin(false); 
      if( rej?.status === 401 ){
        localStorage.clear();
        navigate("/login");
      }  
    }).finally(()=>{
      setShowLoader(false);
    })
  }, [ setNoNet, setShowToast ] )

  const initiateLogin = ({email}) => {
    localStorage.clear();
    return getGoogleAuthUrl({email}).then((gAuth) => {
      // initiateAuth passed instead of getTokenFunction as success callback:
      gAuth && open_popup(gAuth, onOAuthSuccess, email, setRefetchToken, setRedirectPage, setEmail, setShowError, initiateAuth);
    }).catch(e => console.error('Error while getting google auth: ', e));
  }


  useEffect(() => {
    initiateAuth({showMessage:false});
  }, [initiateAuth]);


  useEffect(() => {
    if (admin) setState("adminDetails", admin);
  }, [admin]);

  useEffect(() => {
    setState("authToken", authToken);
  }, [authToken]);

  return (
    <AutherContext.Provider
      value={{
        autherList: authers,
        updateAuthersList: setAuthers,
        admin: admin,
        tenant: tenant,
        setAdmin: setAdmin,
        setEmail: setEmail,
        email: email,
        authToken: authToken,
        setAuthToken: setAuthToken,
        redirectToken: redirectToken,
        setShowError,
        showError,
        setRedirectToken: setRedirectToken,
        userSession,
        setUserSession,
        refetchToken,
        setRefetchToken,
        setShowLoader,
        setRedirectPage,
        initiateLogin,
        showLoader,
        userDetails
      }}
    >
      {props.children}
    </AutherContext.Provider>
  );
}
